import { Content } from 'shared/components/Content';
import { WelcomeContainer } from '../WelcomeContainer';
import { GuideList } from 'shared/components/GuideList';
import { EWantTypeId } from 'shared/types/wantType';
import { useCallback, useState } from 'react';
import { TGuideList } from 'shared/types/giude';
import { SALE_GUIDE_LIST } from 'shared/constants/sell';
import { RENT_GUIDE_LIST } from 'shared/constants/rent';

export const ContentContainer: React.FC = () => {
  const [activeItem, setActiveItem] = useState<EWantTypeId>(EWantTypeId.Sell);

  const [activeList, setActiveList] = useState<TGuideList[]>(SALE_GUIDE_LIST);

  const handleActiveItem = useCallback((newItem: EWantTypeId) => {
    setActiveItem(newItem);
    setActiveList(() => (newItem === EWantTypeId.Sell ? SALE_GUIDE_LIST : RENT_GUIDE_LIST));
  }, []);

  return (
    <Content
      welcome={<WelcomeContainer onActiveItemId={handleActiveItem} itemId={activeItem} />}
      guide={<GuideList list={activeList} activeType={activeItem} />}
    />
  );
};
